import { Component } from '@angular/core';

@Component({
    selector: 'app-track-info',
    templateUrl: './track-info.component.html',
    styleUrls: ['./track-info.component.css'],
    standalone: false
})
export class TrackInfoComponent {
}
